<script lang="ts" setup>
import { ref } from "vue";

import AccountSettings from "./AccountSettings.vue";
import AppearanceSettings from "./AppearanceSettings.vue";
import NotificationsSettings from "./NotificationsSettings.vue";

type Panel = "account" | "appearance" | "notifications" | null;

const openPanel = ref<Panel>("account");

const toggle = (panel: Exclude<Panel, null>) => {
    openPanel.value = openPanel.value === panel ? null : panel;
};
</script>

<template>
    <div class="px-0">
        <AccountSettings
            :collapsed="openPanel !== 'account'"
            :handleToggle="() => toggle('account')"
        />

        <AppearanceSettings
            :collapsed="openPanel !== 'appearance'"
            :handleToggle="() => toggle('appearance')"
        />

        <NotificationsSettings
        :collapsed="openPanel !== 'notifications'"
        :handleToggle="() => toggle('notifications')"
        />
    </div>
</template>
